import { useProduct } from "@/contexts/ProductContext";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Package } from "lucide-react";
import { useTranslation } from "@/contexts/LanguageContext";

export function ProductSelector() {
  const { selectedProduct, setSelectedProduct, products, isLoading } = useProduct();
  const { t } = useTranslation();

  if (isLoading || products.length === 0) return null;

  return (
    <Select
      value={selectedProduct?.id}
      onValueChange={(value) => {
        const product = products.find((p) => p.id === value);
        if (product) setSelectedProduct(product);
      }}
    >
      <SelectTrigger className="w-[280px]">
        <Package className="mr-2 h-4 w-4" />
        <SelectValue placeholder={t('selectProduct')} />
      </SelectTrigger>
      <SelectContent>
        {products.map((product) => (
          <SelectItem key={product.id} value={product.id}>
            <div className="flex items-center gap-2">
              {product.logo_url && (
                <img
                  src={product.logo_url}
                  alt={product.name}
                  className="h-4 w-4 object-contain"
                />
              )}
              <span>{product.name}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
